import apiClient from '../lib/apiClient'

export const themeService = {
  // Public custom themes (admin-authored, marked public). No auth required.
  async getPublicThemes() {
    const response = await apiClient.get('/api/themes')
    return response.data?.data || response.data || []
  },
}
